import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const INACCESSIBLE_BIOENTITIES_QUERY = gql`
  query InaccessibleBioentitiesQuery($ids: [StrictString]!) @skipAudit @engComponent(name: INVENTORY) {
    bioentities(ids: $ids) {
      ... on RegistryItemInterface {
        __typename
        id
        name
      }
      ... on InaccessibleInfoNode {
        ...InaccessibleInfoGraphQL
      }
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const BIOENTITIES_QUERY = gql`
  query BioentitiesQuery($ids: [StrictString!]!) @skipAudit @engComponent(name: INVENTORY) {
    bioentities(ids: $ids) {
      ...BioentityChipOrInaccessibleGraphQL
    }
  }
  ${getFragmentWrapper('BioentityChipOrInaccessible').fragment}
`;
